import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { routes } from "Projects/config/routes";
import ProjectDetails from "Projects/routes/ProjectDetails";
const {
  progress: { path },
} = routes;
export default store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "project-group" */ "./components/Progress"
          ),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ProjectDetails(store)],
  };
};
